// Approved 2027 packet, pages 1–2. Amounts are integer cents.
export const sponsorshipYear = 2027;
export const artworkEmail = "Sponsorship@smithfieldlittleleague.org";
// User resolved the packet's conflicting year on October 23, 2026.
export const artworkDeadline: string | null = "March 1, 2027";
export type SponsorshipPackage = {
  id: string;
  name: string;
  amountCents: number;
  benefits: string[];
  logoPlacement: boolean;
  teamIncluded: boolean;
  oneFieldSign: boolean;
  capacity?: number;
};
export const sponsorshipPackages: SponsorshipPackage[] = [
  {
    id: "grand-slam", name: "Grand Slam Sponsorship", amountCents: 300000,
    capacity: 1, logoPlacement: true, teamIncluded: false, oneFieldSign: false,
    benefits: [
      "Company logo on the sleeve of EVERY SLL uniform (550+ players)",
      "3 field signs (Whipple, Deerfield & Connell)",
      "Website logo and link", "Social media recognition", "Eight banquet tickets", "Sponsor plaque",
    ],
  },
  {
    id: "home-run", name: "Home Run Sponsorship", amountCents: 120000,
    logoPlacement: true, teamIncluded: true, oneFieldSign: false,
    benefits: ["Team sponsorship — name on team shirts", "2 field signs (Whipple & Deerfield)", "Website logo and link", "Social media recognition", "Two banquet tickets", "Sponsor plaque"],
  },
  {
    id: "team", name: "Team Sponsorship", amountCents: 60000,
    logoPlacement: false, teamIncluded: true, oneFieldSign: true,
    benefits: ["Team sponsorship — name on team shirts", "Sign at one field", "Sponsor plaque"],
  },
  {
    id: "field-sign", name: "Field Sign Sponsorship", amountCents: 40000,
    logoPlacement: false, teamIncluded: false, oneFieldSign: true,
    benefits: ["Sign at one field", "8′ × 3′ vinyl sign with logo/lettering message", "Messaging subject to approval by Smithfield Little League"],
  },
];
export const divisions = ["No Preference", "Teenage Division", "Majors Division", "AAA Division", "AA Division", "A Division", "BlastBall", "Challenger"];
export const fieldPreferences = ["No Preference", "Whipple", "Deerfield", "Connell"];
export function artworkInstructions(pkg: SponsorshipPackage): string {
  const content = pkg.logoPlacement ? "your logo, sign artwork, and any placement text" : "your sign artwork and lettering/text";
  return `Email ${content} to ${artworkEmail}.${artworkDeadline ? ` Submit by ${artworkDeadline}.` : ""}`;
}
export type SponsorDetails = {
  businessName: string; contactName: string; email: string; phone: string;
  address: string; website: string; division: string; field: string;
  shirtName: string; signMessage: string; notes: string;
};
export function inquiryText(pkg: SponsorshipPackage, details: SponsorDetails): string {
  return [
    `${sponsorshipYear} sponsorship inquiry — not a paid sponsorship or reservation`,
    `Package: ${pkg.name}`, `Price: $${(pkg.amountCents / 100).toLocaleString("en-US")}`,
    `Sponsor name: ${details.businessName}`, `Contact name: ${details.contactName}`,
    `Email: ${details.email}`, `Phone: ${details.phone}`, `Business address: ${details.address}`,
    `Website: ${details.website || "Not supplied"}`,
    ...(pkg.teamIncluded ? [`Preferred division: ${details.division}`] : []),
    `Additional information: ${details.notes || "None"}`,
  ].join("\n");
}
